module.exports = __webpack_public_path__ + "static/oes.e51bb4ba.png";